<template>
  <div class="download-box" v-if="show">
    <div class="left">
      <div class="icon"><img src="@/assets/img/gkztc_logo.png" alt=""></div>
      <div class="text">
        高考直通车App<br>
        助你直通大学
      </div>
    </div>
    <div class="right-btn" @click="download()">立即下载</div>
    <img class="close" src="@/assets/img/dianbo/close.png" alt="" @click="close">
  </div>
</template>

<script>
import openapp from 'utils/openapp'
export default {
  name: 'appdownload',
  data(){
    return {
      show: true
    }
  },
  created() {
    this.init()
  },
  methods: {
    init(){
      var ua = navigator.userAgent.toLowerCase()
      if(ua.indexOf('gkztc')> -1){
        this.show = false
      }
    },
    download() {
      // console.log('openapp')
      openapp('gkztc://') //打开app
    },
    close(){
      this.show = false
    }
  }
}
</script>

<style lang="scss" scoped>
.download-box{
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
  max-width: 768px;
  height: 2.8rem;
  background-color: rgba(5, 5, 5, 0.3);

  .left{
    float: left;
    margin-left: 1rem;
    margin-top: 0.4rem;
    .icon{
      width: 2rem;
      height: 2rem;
      float: left;
    }
    img{
      width: 100%;
      height: 100%;
    }
    .text{
      float: left;
      color: rgba(255, 255, 255, 1);
      font-size: 0.6rem;
      line-height: 1rem;
      text-align: left;
      margin-left: 0.5rem;
    }
  }
  .right-btn{
    width: 3.8rem;
    height: 1.6rem;
    margin-top: 0.6rem;
    float: right;
    margin-right: 1.2rem;
    color: rgba(255, 255, 255, 1);
    background:linear-gradient(270deg,rgba(51,209,255,1) 0%,rgba(35,130,255,1) 100%);
    border-radius:0.2rem;
    font-size: 0.7rem;
    line-height: 1.6rem;
    text-align: center;
  }
  .close{
    display: block;
    width: 0.8rem;
    height: 0.8rem;
    position: absolute;
    right: 2px;
    top: 2px;
  }
}
</style>
